import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

interface BackendHealthStatus {
  isConnected: boolean;
  isChecking: boolean;
  error: Error | null;
}

const HEALTH_CHECK_INTERVAL = 10000;

//const BASE_URL = `${window.location.origin.replace(":3000", ":8000")}/api`;
const BASE_URL = process.env.REACT_APP_API_URL;

export const useBackendHealth = () => {
  const [status, setStatus] = useState<BackendHealthStatus>({
    isConnected: true,
    isChecking: true,
    error: null,
  });

  const checkBackendHealth = useCallback(async () => {
    try {
      await axios.get(`${BASE_URL}/health/`, {
        timeout: 5000,

        // ✅ on empêche les interceptors de casser la requête
        headers: {},
        transformRequest: [(data, headers) => {
          delete headers.Authorization;
          delete headers['X-Tenant'];
          return data;
        }],
      });

      setStatus({
        isConnected: true,
        isChecking: false,
        error: null,
      });

      return true;
    } catch (error: any) {
      setStatus({
        isConnected: false,
        isChecking: false,
        error,
      });

      return false;
    }
  }, []);

  const retry = useCallback(() => {
    setStatus((prev) => ({ ...prev, isChecking: true }));
    checkBackendHealth();
  }, [checkBackendHealth]);

  useEffect(() => {
    let isMounted = true;

    const runCheck = async () => {
      if (!isMounted) return;
      await checkBackendHealth();
    };

    runCheck();

    const interval = setInterval(runCheck, HEALTH_CHECK_INTERVAL);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [checkBackendHealth]);

  return {
    ...status,
    retry,
  };
};